import React from 'react';
import { useSelector } from 'react-redux';

import Container from '@Components/layout/Container';
import Layout from '@Components/layout/Layout';
import Row from '@Components/layout/Row';
import Slider from '@Components/Slider';
import { SlideItem } from '@Components/Slider/Slide';
import StaticPageContent from '@Components/StaticPageContent/StaticPageContent';
import { Messages } from '@Config/messages';
import { useTranslations } from '@Hooks/useTranslations';
import ContactPageImage from '@Images/contact.jpg';
import ContactBox from '@Routes/contact/ContactBox';
import { getContactUsPage } from '@Store/app/app.selectors';

import styles from './ContactPage.module.scss';

const ContactPage: React.FunctionComponent = () => {
  const t = useTranslations();
  const contactUsPageData = useSelector(getContactUsPage);

  const slides: SlideItem[] = [
    {
      title: t(Messages.contactPageHeading),
      text: t(Messages.contactPageDescription),
      image: ContactPageImage,
    },
  ];

  const contactBoxes = [
    {
      icon: 'facebook',
      text: Messages.contactPageFacebookLabel,
    },
    {
      icon: 'envelope',
      text: Messages.contactPageEmailLabel,
    },
    {
      icon: 'mobile',
      text: Messages.contactPageMobileLabel,
    },
  ] as const;

  return (
    <Layout>
      <Container className={styles.contactPageWrapper}>
        <Slider slides={slides} />
        <Row className={styles.contactBoxesWrapper}>
          {contactBoxes.map((contactInfo, index) => (
            <ContactBox key={index} icon={contactInfo.icon} text={t(contactInfo.text)} />
          ))}
        </Row>

        {contactUsPageData.slug && (
          <Row>
            <StaticPageContent slug={contactUsPageData.slug} />
          </Row>
        )}
      </Container>
    </Layout>
  );
};

export default ContactPage;
